<% if (provider_type_message) { %>
<div class="message message-info">
  <div class="paragraph paragraph-with-icon">
    <div class="paragraph-icon">
      <%= provider_type_message.icon %>
    </div>
    <div class="paragraph-content">
    <% if (provider_type_message.body) { %>
      <p class="paragraph-content__title paragraph-content__title--with-caret" data-appointment-booking-wizard-behaviour="show-provider-type-description" role="button" tabindex="0">
    <% } else { %>
      <p class="paragraph-content__title>
    <% } %>
        <strong><%= provider_type_message.title %></strong>
      </p>
      <p class="paragraph-content__text provider-type-description"><%= provider_type_message.body %></p>
    </div>
  </div>
</div>
<% } %>
